const translateToSegmentProductType = type => {
  const lowerType = type.toLowerCase()
  const productTypes = {
    card: 'credit_card',
    loan: 'loan',
    default: lowerType
  }
  return productTypes[lowerType] || productTypes.default
}

export default translateToSegmentProductType
